import { useMemo } from 'react';
import { required, useRecordContext } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import {
  UserGroupRulesInputs,
  transformUserGroupData,
  userGroupRecordToFormValues,
} from './userGroupRules';

export const UserGroupEdit = () => (
  <MoonstarEdit
    redirect="list"
    transform={transformUserGroupData}
    hideDelete={(record) => record.source === 'system'}
  >
    <UserGroupEditForm />
  </MoonstarEdit>
);

const UserGroupEditForm = () => {
  const record = useRecordContext();
  const defaultValues = useMemo(
    () => userGroupRecordToFormValues(record),
    [record]
  );

  return (
    <MoonstarEditForm defaultValues={defaultValues}>
      <SimpleStack>
        <TextInput source="name" validate={required()} />
        <UserGroupRulesInputs />
      </SimpleStack>
    </MoonstarEditForm>
  );
};
